import { configureStore } from '@reduxjs/toolkit'
import {createManagedResource} from "../../vendor/react-relaxful/relax/resourceCreator";
import axios from "axios";

axios.interceptors.request.use(
    (config) => {
        config.headers['Authorization'] = `Bearer ${import.meta.env.VITE_APP_PUBLIC_API_KEY}`
        return config
    },
)

const api_url = `${import.meta.env.VITE_APP_URL}`
const host_url = (new URL(window.location.href)).origin;

/**
 * Registry of all managed resource stores
 */

const organizationId = document.getElementById('tukios-payment-app')?.dataset?.organizationId;
export const paymentEntity = createManagedResource('payment', `organizations/${organizationId}/payments`, host_url)
export const obituaryEntity = createManagedResource('obituary', 'api/v1/obituaries', api_url)

/**
 * Root Redux Store
 */
export const store = configureStore({
    reducer: {
        paymentReducer: paymentEntity.reducer,
        obituaryReducer: obituaryEntity.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false
    }),
    devTools: import.meta.env.VITE_APP_ENV !== 'production',
})
